import { render } from "./customizing-spacing.md?vue&type=template&id=b968374a"
const script = {}
script.render = render

export default script